import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { io } from "socket.io-client";
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import AuthModal from '../pages/AuthModal';
import { useAuth } from '../context/AuthContext';
import API from '../api'; // 👈 Import API để gọi backend lấy số lượng

export default function MainLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  
  // State số lượng thông báo
  const [pendingCount, setPendingCount] = useState(0); 
  
  // 👇 State cho thông báo Toast (Popup)
  const [toast, setToast] = useState(null); 

  const { user } = useAuth();

  // 1. Hàm lấy số lượng chờ duyệt từ Server (Chuẩn nhất)
  const fetchPendingCount = async () => {
      try {
          // Gọi API đếm số lượng (Đảm bảo backend có route này)
          const res = await API.get('/locations/admin/pending-count');
          if (res.data.success) {
              setPendingCount(res.data.count);
          }
      } catch (error) {
          console.error("Lỗi lấy số lượng pending:", error);
      }
  };

  // 2. Hàm hiển thị Toast thông báo rồi tự tắt
  const showToastNotification = (message) => {
      setToast(message);
      // Tự động tắt sau 3 giây (3000ms)
      setTimeout(() => {
          setToast(null);
      }, 3000);
  };

  useEffect(() => {
    // Kết nối Socket
    const socket = io(process.env.REACT_APP_BACK_END_API_URL || "http://localhost:5000", { 
      transports: ["websocket"] 
    });

    if (user && user.role === 'admin') {
        // A. Lần đầu vào trang: Lấy số lượng ngay lập tức
        fetchPendingCount();

        socket.emit("join_admin_room");

        // B. Sự kiện: Có người gửi món mới
        socket.on("new_proposal", (data) => {
            // 1. Hiện thông báo đẹp (Toast) thay vì alert
            showToastNotification(`🔔 Mới: ${data.data.name || 'Địa điểm mới'} vừa được gửi!`);
            
            // 2. Cập nhật số lượng (Cộng thêm 1 hoặc gọi lại API cho chắc)
            fetchPendingCount(); 
        });
        
        // C. Sự kiện: Khi Admin duyệt/xóa (Refresh)
        socket.on("refresh_pending_count", () => {
             console.log("♻️ Dữ liệu thay đổi, cập nhật lại số lượng...");
             // 👇 Gọi lại API để số nhảy về đúng thực tế (giảm xuống)
             fetchPendingCount(); 
        });
    }

    return () => {
      socket.disconnect();
    };
  }, [user]);

  return (
    <div className="app-container" style={{ position: 'relative' }}>
      
      {/* 👇 COMPONENT TOAST THÔNG BÁO (Tự chế, không cần thư viện) */}
      {toast && (
        <div style={{
            position: 'fixed',
            top: '80px', // Né cái Header ra
            right: '20px',
            backgroundColor: '#2ecc71', // Màu xanh lá
            color: 'white',
            padding: '15px 25px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            zIndex: 9999,
            animation: 'slideIn 0.5s ease-out',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            fontWeight: 'bold'
        }}>
            <span>✅</span>
            <span>{toast}</span>
        </div>
      )}

      <Header 
        onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} 
        onOpenAuth={() => setShowAuthModal(true)}
        pendingCount={pendingCount} 
      />

      <div className="body-container">
        <Sidebar 
          isOpen={isSidebarOpen} 
          onCloseMobile={() => setIsSidebarOpen(false)} 
          pendingCount={pendingCount} 
        />
        
        <main className="main-content">
          <div style={{ width: '100%', height: '100%', overflowY: 'auto' }}>
            <Outlet context={{ setPendingCount, fetchPendingCount }} />
          </div> 
        </main>
      </div>

      <Footer />
      {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}
      
      {/* Thêm chút CSS animation cho mượt */}
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}